module.exports = __webpack_public_path__ + "static/media/rules_and_consequences_living_room.54883ff9.png";